/*
 * casa-gallery-events.js: which product photo shoppers reach, on every product page (Oct 29 2026).
 *
 * Why: gallery_slide from casa-pdp-analytics only ran on mirror pages, and nothing carried it on:
 * GA4 comes only from the Google & YouTube app pixel (no gtag on the page, so dataLayer goes nowhere)
 * and no theme code called clarity(). Galleries could not tell which photo people stop on.
 *
 * Listens to every gallery: Horizon media-gallery ('slideshow:select', zoom 'zoom-media:selected') and
 * 'casa:gallery:slide' from casa-warm-pdp.js, casa-octamirror-v9.js (mirror V9 gallery) and casa-photo-viewer.js (its viewer). Each photo number is sent once per page and place
 * (gallery or zoom), from photo 2 on (photo 1 is every page view):
 *   1. Shopify.analytics.publish('casa_gallery_slide', { slide, total, where, product, product_id, template, env })
 *      -> the "Casa gallery to GA4" custom pixel (docs/analytics/casa-gallery-ga4-pixel.js) sends GA4 event
 *      gallery_slide to G-BWW32CQYP5.
 *   2. Clarity: event gallery_swipe (once) and tag gallery_reached = furthest photo number.
 * Clarity only loads on the store theme (casa-clarity-deferred), so on staging the calls are skipped.
 * No PII. Analytics must never break the page.
 */
(function () {
  'use strict';
  if (window.__casaGalleryEvents) return;
  window.__casaGalleryEvents = true;

  var me = document.currentScript || document.querySelector('script[data-casa-gallery-events]');
  var info = {
    product: (me && me.dataset.productHandle) || '',
    product_id: (me && me.dataset.productId) || '',
    template: (me && me.dataset.template) || '',
    /* Staging, previews and our QA visits are 'qa', so GA4 can keep them out of the real numbers. */
    env: (function () {
      var role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
      return role === 'main' && !/[?&](preview_theme_id|casa_pdp_qa)=/.test(location.search) ? 'live' : 'qa';
    })()
  };
  var sent = {};
  var furthest = 1;
  var swiped = false;

  function clarity() {
    try {
      if (typeof window.clarity === 'function') window.clarity.apply(null, arguments);
    } catch (e) { /* noop */ }
  }

  function record(slide, total, where) {
    slide = Number(slide);
    total = Number(total) || null;
    if (!(slide >= 2)) return;
    var key = where + ':' + slide;
    if (sent[key]) return;
    sent[key] = true;
    var payload = {
      slide: slide,
      total: total,
      where: where,
      product: info.product,
      product_id: info.product_id,
      template: info.template,
      env: info.env
    };
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('casa_gallery_slide', payload);
      }
    } catch (e) { /* noop */ }
    try {
      document.dispatchEvent(new CustomEvent('casa:gallery:recorded', { detail: payload }));
    } catch (e) { /* noop */ }
    if (!swiped) {
      swiped = true;
      clarity('event', 'gallery_swipe');
    }
    if (slide > furthest) {
      furthest = slide;
      clarity('set', 'gallery_reached', String(slide));
    }
  }

  /* casa-warm gallery (Solace, Phoenix and other casa-warm-product pages) */
  document.addEventListener('casa:gallery:slide', function (e) {
    var d = e.detail || {};
    record(d.index, d.total, d.where === 'zoom' ? 'zoom' : 'gallery');
  });

  /* Horizon media-gallery (mirror pages and the stock product pages); the zoom view is a dialog */
  document.addEventListener('slideshow:select', function (e) {
    var t = e.target;
    var g = t && t.closest && t.closest('media-gallery, zoom-dialog, dialog');
    if (!g) return;
    var d = e.detail || {};
    if (typeof d.index !== 'number') return;
    var slides = t.querySelectorAll ? t.querySelectorAll('slideshow-slide') : [];
    record(d.index + 1, slides.length, t.closest('dialog, zoom-dialog') ? 'zoom' : 'gallery');
  });

  /* Horizon zoom view (zoom-dialog.js): a scrolled list, not a slideshow, so it sends zoom-media:selected */
  document.addEventListener('zoom-media:selected', function (e) {
    var d = e.detail || {};
    if (typeof d.index !== 'number') return;
    var g = e.target && e.target.closest && e.target.closest('media-gallery');
    var slides = g ? g.querySelectorAll('slideshow-slide') : [];
    record(d.index + 1, slides.length, 'zoom');
  });
})();
